<template>
  <div class="page">
    <div class="list-page page-container overflow-hidden">
      <a-list v-if="list.length > 0">
        <RecycleScroller
          v-infinite-scroll="handleInfiniteOnLoad"
          key-field="reservNo"
          class="list-container"
          :items="list"
          :item-size="120"
          :infinite-scroll-disabled="busy"
          :infinite-scroll-distance="10"
        >
          <a-list-item slot-scope="{ item }" class="list-item">
            <div class="list-item-main flex-hb-vc">
              <div class="list-item-left flex-v">
                <h4>{{ item.departurePortName }} - {{ item.arrivalPortName }}</h4>
                <span>预约单号：{{ item.reservNo }}</span>
                <span>提交时间：{{ item.createTime | getFormatDate }}</span>
              </div>
              <div class="list-item-right flex-hl-vc" @click="goToPage('Detail', item.id)">{{ item.status | getStatusCn }} <a-icon type="right" /></div>
            </div>
          </a-list-item>
        </RecycleScroller>
      </a-list>
      <div v-else class="flex-hc-vc">
        <p>暂无数据</p>
      </div>
    </div>

    <div class="loading-container" v-if="loading">
      <a-spin class="loading"/>
    </div>
  </div>
</template>
<script>
import { fetchGjpReservList } from '@/apis/customized'
import moment from 'moment'
import { debounce } from 'lodash'
import infiniteScroll from 'vue-infinite-scroll'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import './index'

const statusMap = {
  'WC': '已预约待确认',
  'OPEN': '航班开通已回复',
  'CANCEL': '航班取消已回复',
  'XX': '取消预约'
}

export default {
  directives: { infiniteScroll },
  components: {
    RecycleScroller
  },
  data () {
    return {
      list: [],
      loading: false,
      busy: true,
      page: 1,
      pageSize: 10
    }
  },
  created () {
    this.fetchListData(true)
  },
  methods: {
    async fetchListData (isFirst = true) {
      this.loading = true
      const { page, pageSize } = this
      const params = {
        page: page,
        pageSize: pageSize
      }
      const result = await fetchGjpReservList(params)
      if (isFirst) {
        this.list = result.list.map((item, index) => ({ ...item, index }))
      } else {
        this.list = this.list.concat(result.list).map((item, index) => ({ ...item, index }))
      }
      if (page * pageSize > result.totalResultCount) {
        this.busy = false
      }
      this.page++
      this.loading = false
    },
    handleInfiniteOnLoad: debounce(function () {
      const { busy, page } = this
      if (busy && page > 1) {
        this.fetchListData(false)
      }
    }, 1000),
    goToPage (pageName, id) {
      this.$router.push({ path: `/server/intlTicketBooking${pageName}`, query: { id } })
    }
  },
  filters: {
    getStatusCn (value) {
      return statusMap[value]
    },
    getFormatDate (value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
